package com.essntl.features.itinerary.ui

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import core.dateformat.utils.dateInRange
import com.essntl.features.area.domain.model.AreaModel
import com.essntl.features.client.domain.model.ClientModel
import com.essntl.features.itinerary.domain.model.ItineraryFilterOptions
import com.essntl.features.itinerary.domain.model.ItineraryModel
import com.essntl.features.itinerary.domain.model.ItineraryServiceModel
import com.essntl.features.itinerary.domain.use_case.SortItineraries
import com.essntl.features.task.domain.model.TaskModel
import kotlinx.datetime.LocalDate

/** AllItinerary **/
@Composable
fun rememberFilteredItineraries(
    itineraries: List<ItineraryModel>?,
    filterOptions: ItineraryFilterOptions,
): List<ItineraryModel> {
    return remember(itineraries, filterOptions) {
        SortItineraries(
            itineraries = itineraries.orEmpty(),
            filterOptions = filterOptions,
        )
    }
}

val List<AreaModel>?.combinedAreas
    @Composable
    get() = this.orEmpty()
        .map { it.name ?: "" }
        .filter { it.isNotEmpty() }
        .joinToString(", ")
        .ifEmpty { "Unknown destination" }

/** EditItinerary **/
@Composable
fun rememberTodosCount(
    tasks: List<TaskModel>?,
): Int {
    return remember(tasks) {
        tasks?.count {
            it.status == TaskModel.Status.Todo
        } ?: 0
    }
}

@Composable
fun rememberSupplierPurchaseEnabled(
    selectedItineraryServiceList: List<ItineraryServiceModel>,
): Boolean =
    remember(selectedItineraryServiceList) {
        val supplier = selectedItineraryServiceList.firstOrNull()?.supplier ?: return@remember false

        selectedItineraryServiceList.all {
            it.supplier == supplier
        }
    }

@Composable
fun rememberClientPurchaseEnabled(
    selectedItineraryServiceList: List<ItineraryServiceModel>,
    client: ClientModel?,
): Boolean {
    return remember(selectedItineraryServiceList, client) {
        if (client == null) return@remember false

        selectedItineraryServiceList.all {
            it.status == ItineraryServiceModel.Status.Confirmed
        }
    }
}

@Composable
fun rememberConfirmedItineraryServicesList(
    itineraryServices: List<ItineraryServiceModel>,
): List<ItineraryServiceModel> {
    return remember(itineraryServices) {
        itineraryServices
            .filter {
                it.status == ItineraryServiceModel.Status.Confirmed
            }
            .sortedBy { LocalDate.parse(it.startDate) }
    }
}

/** EditItineraryService **/

@Composable
fun rememberDateRange(
    date: String?,
    fromDate: String?,
    endDate: String?,
): Boolean? {
    return remember(date, fromDate, endDate) {
        dateInRange(
            date = date,
            fromDate = fromDate,
            toDate = endDate,
        )
    }
}